import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const getTabletGrid = (props) => {
  const grid = ['header header', 'media content', 'cta cta'];
  if (!props.hasCta) grid.pop();
  return grid.map((item) => `'${item}'`).join(' ');
};

const getDesktopGrid = (props) => {
  const grid =
    props.layout === 'Media Right'
      ? ['header media', 'content media', 'cta media']
      : ['media header', 'media content', 'media cta'];
  if (!props.hasCta) grid.pop();
  return grid.map((item) => `'${item}'`).join(' ');
};

export const StyledMediaAndText = styled.article`
  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${themeGet('scale.scaleUp04')};
    align-items: center;
    grid-template-areas: ${getTabletGrid};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    grid-column-gap: ${themeGet('scale.scaleUp14')};
    grid-template-areas: ${getDesktopGrid};
  }
`;

export const StyledHeader = styled.header`
  grid-area: header;
  margin-bottom: ${themeGet('scale.scaleBase')};
  text-align: center;

  h2 {
    font-size: ${themeGet('scale.scaleUp04')};
    margin: 0;
  }

  p {
    ${themeGet('font.whitneySemibold')}
    font-size: ${themeGet('scale.scaleBase')};
    color: ${themeGet('color.colorGrayBlue70')};
    margin: ${themeGet('scale.scaleBase')} 0 0;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    margin-bottom: ${themeGet('scale.scaleUp05')};

    h2 {
      font-size: ${themeGet('scale.scaleUp05')};
    }

    p {
      font-size: ${themeGet('scale.scaleUp02')};
      margin-top: ${themeGet('scale.scaleDown03')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    text-align: left;
    margin-bottom: ${themeGet('scale.scaleUp01')};
    margin-top: auto;

    h2 {
      font-size: ${themeGet('scale.scaleUp07')};
    }

    p {
      margin-top: ${themeGet('scale.scaleUp03')};
    }
  }
`;

export const StyledMedia = styled.figure`
  grid-area: media;
  margin-bottom: ${themeGet('scale.scaleUp03')};
  overflow: hidden;
  box-shadow: ${(props) =>
    props.mediaType === 'CodeExample'
      ? '0 0 1px 0 #a8b9d5, 0 7px 11px -4px rgba(0, 23, 62, 0.2)'
      : null};

  @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
    .gatsby-image-wrapper {
      max-height: 270px;
      img {
        object-fit: contain !important;
      }
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    margin-bottom: 0;
  }
`;

export const StyledContent = styled.div`
  grid-area: content;

  p {
    font-size: ${themeGet('scale.scaleBase')};
    margin: 0;
  }

  ul {
    border-top: ${themeGet('scale.scaleDown05')} solid
      ${themeGet('color.colorGrayBlue30')};
    padding-top: ${themeGet('scale.scaleUp03')};
    margin-top: ${themeGet('scale.scaleUp03')};
  }

  li {
    ${themeGet('font.whitneyMedium')}
    display: grid;
    grid-template-columns: ${themeGet('scale.scaleUp01')} auto;
    grid-column-gap: ${themeGet('scale.scaleDown03')};
    font-size: ${themeGet('scale.scaleDown01')};
    color: ${themeGet('color.colorGrayBlue80')};
  }

  li + li {
    margin-top: ${themeGet('scale.scaleUp03')};
  }

  svg {
    width: 100%;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    p {
      font-size: ${themeGet('scale.scaleBase')};
    }

    li {
      font-size: ${themeGet('scale.scaleDown01')};
      grid-template-columns: ${themeGet('scale.scaleUp03')} auto;
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-bottom: ${(props) => (props.hascta ? 0 : 'auto')};

    p {
      font-size: ${themeGet('scale.scaleUp02')};
    }

    ul {
      margin-top: ${themeGet('scale.scaleUp05')};
      padding-top: ${themeGet('scale.scaleUp05')};
    }

    li {
      font-size: ${themeGet('scale.scaleBase')};
    }
  }
`;

export const StyledCta = styled.div`
  grid-area: cta;
  text-align: center;
  margin-top: ${themeGet('scale.scaleUp05')};

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    margin-top: ${themeGet('scale.scaleUp08')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    text-align: left;
    margin-top: ${themeGet('scale.scaleUp09')};
    margin-bottom: auto;
  }
`;
